import React from "react";
import LoaderImage from "../static/loading.svg";
import H4 from "./Typography/H4";

type LoaderProps = {
  show: boolean;
};
const Loader: React.FC<LoaderProps> = ({ show }): React.ReactElement | null => {
  return show ? (
    <div className="flex w-full top-0 left-0 h-full absolute items-center justify-center bg-white opacity-75">
      <div className="animate-pulse">
        <H4>Loading...</H4>
      </div>
    </div>
  ) : null;
};

export default Loader;
